import * as echarts from 'echarts';


function getColor(color1, color2) {
	return new echarts.graphic.LinearGradient(
		0, 0, 0, 1, // 从上到下渐变
		[{
			offset: 0,
			color: color1
		}, {
			offset: 1,
			color: color2
		}]
	)
}

function setData(data, name = undefined, color = getColor('#00C0FA', '#015EEA'), barWidth = '5%') {
	return {
		name,
		data,
		type: 'bar',
		barWidth, // 设置柱子宽度（也可以是具体像素：'30'）
		itemStyle: {
			color
		},
		label: {
			color: '#FFF'
		},
	}
}




function getGasList(listNum = 8) {
	let val = [];
	console.log(listNum)
	for (let i = 0; i < listNum; i++) {
		val.push(Number((Math.random() * 300 + 20).toFixed(2)))
	}
	console.log(val)
	return val
}


function setZData(data, color, name = undefined) {
	return {
		name,
		type: 'line',
		data,
		symbol: 'circle',
		symbolSize: 8,
		lineStyle: {
			width: 2,
			color
		},
		itemStyle: {
			color
		},
		areaStyle: {
			color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
					offset: 0,
					color: color
				}, // 顶部：线条颜色
				{
					offset: 1,
					color: 'rgba(0,0,0,0)'
				} // 底部：透明
			])
		}
	}
}

// 智慧能源管理


let mouths = [];
for (let i = 1; i < 13; i++) {
	mouths.push(i + '月')
}

function getVals(num) {
	let arr = [];
	for (let i = 0; i < num; i++) {
		arr.push((Math.random() * 100 + 100).toFixed(0))
	}
	return arr
}

export const chart1 = {
	title: {
		show: false
	},
	tooltip: {
		trigger: 'axis',
		axisPointer: {
			type: 'shadow'
		},
		formatter: '{b} <br/> {a}: {c} kw·h',
	},
	legend: {
		type: 'scroll',
		right: 8,
		top: 10,
		textStyle: {
			color: '#FFF'
		},
	},
	grid: {
		top: '18%',
		left: '3%',
		right: '8%',
		bottom: '3%',
		containLabel: true
	},
	xAxis: {
		type: 'value',
		boundaryGap: [0, 0.01],
		splitLine: {
			show: false
		},
		axisLabel: {
			color: '#07DBFF' // 红色字体
		}
	},
	yAxis: {
		type: 'category',
		data: mouths,
		splitLine: {
			show: false
		},
		axisLabel: {
			color: '#07DBFF' // 红色字体
		}
	},
	series: [
		setData(getVals(12).map((item, index) => {
			if (index < 4 || index > 8) { //如修改  反向判断就好
				return 0
			} else {
				return item
			}
		}), '冷源', getColor('#00eefa', '#57a3ff'), '7')
	]
};


export const chart2 = {
	title: {
		show: false
	},
	tooltip: {
		trigger: 'axis',
		axisPointer: {
			type: 'shadow'
		},
		formatter: '{b} <br/> {a}: {c} kw·h',
	},
	legend: {
		type: 'scroll',
		right: 8,
		top: 10,
		textStyle: {
			color: '#FFF'
		},
		lineStyle: {
			width: '10'
		}
	},
	grid: {
		top: '18%',
		left: '3%',
		right: '8%',
		bottom: '3%',
		containLabel: true
	},
	xAxis: {
		type: 'value',
		boundaryGap: [0, 0.01],
		splitLine: {
			show: false
		},
		axisLabel: {
			color: '#07DBFF' // 红色字体
		}
	},
	yAxis: {
		type: 'category',
		data: mouths,
		splitLine: {
			show: false
		},
		axisLabel: {
			color: '#07DBFF' // 红色字体
		}
	},
	series: [
		setData(getVals(12).map((item, index) => {
			if (index > 3 && index < 9) {
				return 0
			} else {
				return item
			}
		}), '热源', getColor('#f2be21', '#fd954a'), '7')
	]
};
let colors = [
	getColor('#349CFE', '#349CFE'),
	getColor('#5ADE9D', '#5ADE9D'),
	getColor('#0667D4', '#0667D4'),
	getColor('#8D45C5', '#8D45C5'),
	getColor('#2FDC3C', '#2FDC3C'),
	getColor('#FF6130', '#FF6130'),
	getColor('#FE3439', '#FE3439'),
	getColor('#CADE5A', '#CADE5A'),
	getColor('#C334FE', '#C334FE'),
	getColor('#f46566', '#f46566'),
	getColor('#3ED4EB', '#3ED4EB'),
	getColor('#FF9830', '#FF9830'),
]
export const chart3 = {
	tooltip: {
		trigger: 'item'
	},
	legend: {
		// type: 'scroll',
		orient: 'vertical',
		symbol: 'circle',
		left: 20,
		borderType: 'dashed',
		itemGap: 12,
		itemWidth: 4,
		itemHeight: 4,
		top: 50,
		symbol: 'circle', // 设置为圆形
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 10,
			lineHeight: 5
		}
	},
	series: [{
		name: '公共用电（kw · h）',
		type: 'pie',
		radius: ['40%', '90%'],
		avoidLabelOverlap: false,
		label: {
			show: false,
			position: 'center'
		},
		top: 20,
		left: 120,
		itemStyle: {
			borderRadius: 0,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 6
		},
		emphasis: {
			label: {
				show: true,
				fontSize: 40,
				fontWeight: 'bold'
			}
		},
		labelLine: {
			show: false
		},
		data: mouths.map(item => {
			return {
				value: ((Math.random() * 1000) + 500).toFixed(2),
				name: item,
				itemStyle: {
					color: colors[Number(item.replace('月', '')) - 1]
				}
			}
		})
	}]
};

export const chart4 = {
	xAxis: {
		type: 'category',
		data: mouths.map(item => item),
		axisLabel: {
			color: '#05d0e6' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	legend: {
		right: 10,
		top: 10,
		symbol: 'circle', // 设置为圆形
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 10
		}
	},
	grid: {
		top: 68,
		left: 50,
		right: 20,
		bottom: 20,
	},
	tooltip: {
		trigger: 'axis'
	},
	yAxis: {
		type: 'value',
		splitNumber: 2,
		axisLabel: {
			color: '#05d0e6' // 红色字体
		},
		splitLine: {
			show: false
		} // 不显示辅助线
	},
	series: [setZData(getGasList(12).map((item, index) => {
		if (index > 3 && index < 9) { //如修改  反向判断就好
			return 0
		} else {
			return item
		}
	}), '#FF3737', '用气')]
}

export const chart5 = {
	tooltip: {
		trigger: 'item'
	},
	legend: {
		// type: 'scroll',
		orient: 'vertical',
		symbol: 'circle',
		left: 20,
		borderType: 'dashed',
		itemGap: 12,
		itemWidth: 4,
		itemHeight: 4,
		top: 50,
		symbol: 'circle', // 设置为圆形
		symbolSize: [12, 12], // 设置图例圆形的大小
		textStyle: {
			color: '#FFF',
			fontSize: 10,
			lineHeight: 5
		}
	},
	series: [{
		name: '公共用水（t）',
		type: 'pie',
		radius: ['40%', '90%'],
		avoidLabelOverlap: false,
		label: {
			show: false,
			position: 'center'
		},
		top: 20,
		left: 120,
		itemStyle: {
			borderRadius: 0,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 6
		},
		emphasis: {
			label: {
				show: true,
				fontSize: 40,
				fontWeight: 'bold'
			}
		},
		labelLine: {
			show: false
		},
		data: mouths.map((item, index) => {
			return {
				value: index,
				name: item,
				itemStyle: {
					color: colors[Number(item.replace('月', '')) - 1]
				}
			}
		})
	}]
};